<template functional>
    <transition-group name="flip-list" tag="div">
        <slot></slot>
    </transition-group>
</template>

<script>
export default {
    name: "BaseListFlipTransition",
}
</script>

<style lang="scss" scoped>

.flip-list-move {
  transition: transform 1s;
}

</style>